import type { LucideIcon } from "lucide-react";
import {
  Calendar,
  Cpu,
  DollarSign,
  Globe,
  Landmark,
  MapPin,
  MapPinOff,
  Radar,
  Search,
  Tag,
  UserRound,
  Users,
} from "lucide-react";

export type CompanyFilterSectionId =
  | "personas"
  | "nameKeywords"
  | "location"
  | "employees"
  | "industry"
  | "source"
  | "excludeLocations"
  | "domains"
  | "revenue"
  | "technologies"
  | "funding"
  | "hiring";

export type CompanyFilterSection = {
  id: CompanyFilterSectionId;
  label: string;
  defaultOpen: boolean;
  advanced?: boolean;
  /** Only shown on Accounts (workspace) scope */
  workspaceOnly?: boolean;
  icon: LucideIcon;
};

export const COMPANY_FILTER_SECTIONS: CompanyFilterSection[] = [
  { id: "personas", label: "Personas", defaultOpen: true, icon: UserRound },
  {
    id: "nameKeywords",
    label: "Name / keywords",
    defaultOpen: true,
    icon: Search,
  },
  { id: "location", label: "HQ location", defaultOpen: true, icon: MapPin },
  {
    id: "employees",
    label: "# Employees",
    defaultOpen: false,
    icon: Users,
  },
  {
    id: "industry",
    label: "Industry / keyword tags",
    defaultOpen: false,
    icon: Tag,
  },
  {
    id: "source",
    label: "Source / created",
    defaultOpen: true,
    workspaceOnly: true,
    icon: Calendar,
  },
  {
    id: "excludeLocations",
    label: "Exclude locations",
    defaultOpen: false,
    advanced: true,
    icon: MapPinOff,
  },
  {
    id: "domains",
    label: "Domains / org IDs",
    defaultOpen: false,
    advanced: true,
    icon: Globe,
  },
  {
    id: "revenue",
    label: "Revenue",
    defaultOpen: false,
    advanced: true,
    icon: DollarSign,
  },
  {
    id: "technologies",
    label: "Technologies",
    defaultOpen: false,
    advanced: true,
    icon: Cpu,
  },
  {
    id: "funding",
    label: "Funding",
    defaultOpen: false,
    advanced: true,
    icon: Landmark,
  },
  {
    id: "hiring",
    label: "Hiring / intent signals",
    defaultOpen: false,
    advanced: true,
    icon: Radar,
  },
];

export function defaultCompanyOpenMap(): Record<
  CompanyFilterSectionId,
  boolean
> {
  return Object.fromEntries(
    COMPANY_FILTER_SECTIONS.map((s) => [s.id, s.defaultOpen]),
  ) as Record<CompanyFilterSectionId, boolean>;
}

export {
  encodeFiltersParam,
  decodeFiltersParam,
} from "@/lib/filter-url";
